// extracted by mini-css-extract-plugin
export default {"loader":"_28QBz"};